// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CoverMyMedsV1ClientGeneratedPrescriptionDefinitionModel {
    'daysSupply'?: number | null;
    'name'?: string | null;
    'ndc'?: string | null;
    'refills'?: number | null;
    'sig'?: string | null;
    'writtenQuantity'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CoverMyMedsV1ClientGeneratedPrescriptionDefinitionModel>> = [
        {
            "name":     "daysSupply",
            "baseName": "daysSupply",
            "type":     "number"
        },
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "ndc",
            "baseName": "ndc",
            "type":     "string"
        },
        {
            "name":     "refills",
            "baseName": "refills",
            "type":     "number"
        },
        {
            "name":     "sig",
            "baseName": "sig",
            "type":     "string"
        },
        {
            "name":     "writtenQuantity",
            "baseName": "writtenQuantity",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return CoverMyMedsV1ClientGeneratedPrescriptionDefinitionModel.attributeTypeMap;
    }
}
